import { render, staticRenderFns } from "./furnitureshop-banner-02.vue?vue&type=template&id=41071162&scoped=true&"
import script from "./furnitureshop-banner-02.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-banner-02.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-banner-02.vue?vue&type=style&index=0&id=41071162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41071162",
  null
  
)

export default component.exports